module.exports = __webpack_public_path__ + "static/media/minhacentral-logo-background.0903c1f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minhacentral-logo-background.svg
// module id = 1441
// module chunks = 0